export const sumGroupItems = (
	groups: ReadonlyArray<{ items: ReadonlyArray<unknown> }>,
): number => groups.reduce((total, group) => total + group.items.length, 0);
